import {gql} from '@apollo/client';

export const INIT_SUBSCRIPTION = gql`
    mutation t2InitSubscription ($data: InputT2InitSubscription!) {
        t2InitSubscription(data: $data) {
            confirmationId
        }
    }
`
export const CONFIRM_SUBSCRIPTION = gql`
    mutation t2ConfirmSubscription ($data: InputT2ConfirmSubscription!) {
        t2ConfirmSubscription(data: $data) {
            done
        }
    }
`